import React from 'react';
import { Table } from 'react-bootstrap';
import {ActivityYearDay} from "Model/Activity/ActivityYearDay";
import {Activity} from "../../../Model/Activity/Activity";

interface Props {
    activity: Activity
    activityYearDays: ActivityYearDay[];
}

const ActivityYearDaysAvailableSeatsResume: React.FC<Props> = ({ activity, activityYearDays }) => {

    if(!activity.showYearDaysAvailableSeats || !activityYearDays.length){
        return (<></>);
    }

    return (
        <div className="activity-year-days-available-seats-resume py-4">
            <h3 className={"mb-3"}>Resumen de plazas disponibles</h3>
            <Table bordered className={"redTable"}>
                <thead>
                    <tr>
                        <th>Día</th>
                        <th>Plazas disponibles</th>
                        <th>Plazas disponibles para Servicios Sociales</th>
                    </tr>
                </thead>
                <tbody>
                    {activityYearDays.map((day, key) => (
                        <tr key={key}>
                            <td>{day.name}</td>
                            <td>{day.currentAvailableSeats}</td>
                            <td>{day.currentAvailableSocialServicesSeats}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ActivityYearDaysAvailableSeatsResume;
